import React, { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, style, ...props }) => {
  const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    width: '100%',
  };

  return (
    <div style={wrapperStyle}>
      {label && <label className="mono-label" style={{ margin: 0 }}>{label}</label>}
      <input
        className="control-field"
        style={{
          borderColor: error ? 'var(--status-danger)' : undefined,
          ...style,
        }}
        {...props}
      />
      {error && <span style={{ color: 'var(--status-danger)', fontSize: '0.875rem' }}>{error}</span>}
    </div>
  );
};

export default Input;
